const SET_CART_ITEMS = (state, payload) => {
    state.cartitems = payload
}
const SET_CART_COUNT = (state, payload) => {
    state.cartcount = payload
}
const SET_CART_SUMM = (state, payload) => {
    state.cartsumm = payload
}
const SET_PC_DISCOUNT = (state, payload) => {
    state.pc_discount = payload
}
const SET_PC_CODE = (state, payload) => {
    state.pc_code = payload
}
const SET_CHANGED_CART = (state, payload) => {
    state.change_cart = payload
}

export default {
    SET_CART_ITEMS,
    SET_CART_COUNT,
    SET_CART_SUMM,
    SET_PC_DISCOUNT,
    SET_PC_CODE,
    SET_CHANGED_CART
}
